module.exports = __webpack_public_path__ + "static/media/modalComandos.3eec34ee.png";